<template>
	<div>
		<v-combobox
			:class="dense ? 'grv-input-dense' : 'grv-input'"
			class="chiped-input"
			:menu-props="{contentClass: 'grv-menu'}"
			:rules="rules"
			@update:error="errored = $event"
			:value="value"
			clearable
			:items="items"
			:loading="loading"
			item-text="email"
			@blur="onblur()"
			item-value="id"
			:search-input.sync="search"
			:name="param.name"
			:multiple="multiple"
			:readonly="readonly"
			auto-select-first
			:dense="dense"
			no-filter
			hide-no-data
			chips
			:small-chips="dense"
			:deletable-chips="!readonly"
			@paste.native="onPaste($event)"
			placeholder="Rechercher un contact"
			@change="$emit('update:value', $event)">

			<template v-slot:label>
				<Label :param="param"></Label>
			</template>
		</v-combobox>

		<Hint :param="param" :errored="errored"></Hint>
	</div>
</template>

<script>
import { debounce } from 'debounce'
import Label from '@/components/fields/label.vue'
import Hint from '@/components/fields/hint.vue'
export default {
	props: [
		'param',
		'value',
		'readonly',
		'dense'
	],
	components: {
		Label,
		Hint
	},
	data () {
		return {
			rules: [],
			errored: false,
			items: [],
			search: null,
			loading: false,
			pasting: false
		}
	},
	computed: {
		multiple () {
			return this.param.type.indexOf('multi-email') === 0
		}
	},
	watch: {
		search (val) {
			if (val) {
				this.onType(val)
			} else {
				this.items = []
			}
		}
	},
	methods: {
		onblur () {
			this.items = []
			this.search = ''
		},
		onPaste (evt) {
			this.pasting = true
			setTimeout(() => {
				this.pasting = false
			}, 300)
		},
		onType: debounce(function (val) {
			this.$nextTick(() => {
				if (!val) return
				if (val.length < 3) return
				if (this.loading) return
				if (this.pasting) {
					if (/.+@.+/.test(val) ||
						val.indexOf(',') > -1 ||
						val.indexOf(';') > -1) {
						let testValue = val.replace(/ |"/g, '')
						testValue = testValue.split(/,|;/)
						if (Array.isArray(this.value)) {
							this.$emit('update:value', [...this.value, ...testValue])
						} else {
							if (this.multiple) {
								this.$emit('update:value', testValue)
							} else {
								this.$emit('update:value', testValue[0])
							}
						}
						this.items = []
						this.search = ''
						return
					}
				}
				this.loading = true
				this.$EsMaestro.contact_search(val)
					.then(contacts => {
						if (this.return_object) {
							this.items = contacts
						} else {
							this.items = contacts.map(contact => contact.email)
						}
					})
					.catch(err => {
						console.error(err)
					})
					.finally(() => (this.loading = false))
			})
		}, 100),
		emailCheck (value) {
			return /.+@.+/.test(value) || 'Mauvaise mise en forme de l\'email'
		},
		multiEmailCheck (value) {
			let isValid = true
			if (value) {
				let arr = value
				if (!Array.isArray(value)) arr = value.split(',')
				arr.map(email => {
					if (!/.+@.+/.test(email)) isValid = false
				})
			}
			return isValid || 'Mauvaise mise en forme des emails'
		},
		requiredCheck (value) {
			if (value === '') return 'Requis'
			if (value === null) return 'Requis'
			if (value === undefined) return 'Requis'
			if (Array.isArray(value)) {
				if (value.length === 0) return 'Requis'
			}
			return true
		}
	},
	mounted () {
		if (!this.param) return
		if (this.param.required || this.param.required === undefined) {
			this.rules.push(this.requiredCheck)
		}
		if (this.multiple) {
			this.rules.push(this.multiEmailCheck)
		} else {
			this.rules.push(this.emailCheck)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/fields/email.vue